export default {
  RESEND_CODE_PENDING: "RESEND_CODE_PENDING",
  RESEND_CODE_FAILED: " RESEND_CODE_FAILED",
  RESEND_CODE_SUCCESSFULLY: "RESEND_CODE_SUCCESSFULLY",
};
